<template>
  <section class="h5-seat-claim">
    <div class="container">
      <h2 class="title">座位认领</h2>

      <el-card shadow="never" class="mt12">
        <div slot="header" class="clearfix">
          <span>座位信息</span>
        </div>
        <el-descriptions :column="1" border v-if="seatDetail">
          <el-descriptions-item label="赛事名称">{{
            seatDetail.MatchName || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="场馆名称">{{
            seatDetail.VenueName || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{
            seatDetail.Area || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="排数">{{
            seatDetail.RowNumber || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="座位号">{{
            seatDetail.SeatNumber || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag
              :type="
                seatDetail.Status === 0
                  ? 'success'
                  : seatDetail.Status === 1
                  ? 'warning'
                  : seatDetail.Status === 2
                  ? 'info'
                  : 'danger'
              "
            >
              {{
                seatDetail.Status === 0
                  ? "可售"
                  : seatDetail.Status === 1
                  ? "已售"
                  : seatDetail.Status === 2
                  ? "冻结/赠送"
                  : "锁定"
              }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <div v-else class="tc p16">加载中...</div>
      </el-card>

      <el-card shadow="never" class="mt12">
        <div slot="header" class="clearfix">
          <span>身份信息</span>
        </div>

        <div v-if="claimed">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="姓名">{{
              identityInfo.Name || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="身份证号">{{
              identityInfo.IdCard || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{
              identityInfo.Phone || "-"
            }}</el-descriptions-item>
          </el-descriptions>
          <div class="mt12 tip">已提交身份信息，如需修改请联系管理员。</div>
        </div>

        <el-form
          v-else
          :model="form"
          :rules="rules"
          ref="formRef"
          label-width="84px"
        >
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="form.name"
              maxlength="30"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="idCard">
            <el-input
              v-model="form.idCard"
              maxlength="18"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
              v-model="form.phone"
              maxlength="11"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <div class="mt12">
            <el-button
              type="primary"
              :loading="submitting"
              @click="handleSubmit"
              >提交</el-button
            >
          </div>
        </el-form>
      </el-card>
    </div>
  </section>
</template>

<script>
import { getSeatDetailNoPer, submitSeatIdentityNoPer } from "@/api/match/match";

export default {
  data() {
    return {
      seatId: null,
      seatDetail: null,
      submitting: false,
      // 展示已提交信息
      identityInfo: null,
      form: {
        name: "",
        idCard: "",
        phone: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /^\d{17}[\dXx]$/,
            message: "请输入18位二代身份证号",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "请输入11位手机号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    claimed() {
      return !!this.identityInfo;
    },
  },
  mounted() {
    this.seatId = this.$route.query.seatId;
    if (!this.seatId) {
      this.$message.error("缺少座位ID参数");
      return;
    }
    this.fetchSeatDetail();
  },
  methods: {
    fetchSeatDetail() {
      getSeatDetailNoPer({ Id: this.seatId })
        .then((res) => {
          if (res.data && res.data.success) {
            const detail = res.data.response || {};
            this.seatDetail = detail;
            // 优先从 ObjectData 中读取已提交的身份信息（存在则仅展示，不再允许提交）
            const obj = (detail && detail.ObjectData) || {};
            const nameFromObj = obj.Name || obj.RealName || obj.IdentityName;
            const idCardFromObj =
              obj.IdCard || obj.IdentityIdCard || obj.IDCard;
            const phoneFromObj =
              obj.TelPhone || obj.Phone || obj.PhoneNumber || obj.IdentityPhone;

            // 其次兼容 detail 自身可能携带的字段
            const name =
              nameFromObj ||
              detail.IdentityName ||
              detail.Name ||
              detail.RealName;
            const idCard =
              idCardFromObj ||
              detail.IdentityIdCard ||
              detail.IdCard ||
              detail.IDCard;
            const phone =
              phoneFromObj ||
              detail.IdentityPhone ||
              detail.Phone ||
              detail.PhoneNumber;

            if (name || idCard || phone) {
              this.identityInfo = {
                Name: name || "",
                IdCard: idCard || "",
                Phone: phone || "",
              };
            } else {
              this.identityInfo = null;
            }
          } else {
            this.$message.error(
              (res.data && res.data.message) || "获取座位信息失败"
            );
          }
        })
        .catch(() => {
          this.$message.error("获取座位信息失败");
        });
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        const payload = {
          SeatId: this.seatId,
          Name: this.form.name,
          IdCard: this.form.idCard,
          Phone: this.form.phone,
        };
        submitSeatIdentityNoPer(payload)
          .then((res) => {
            this.submitting = false;
            if (res.data && res.data.success) {
              this.$message.success("提交成功");
              this.identityInfo = {
                Name: this.form.name,
                IdCard: this.form.idCard,
                Phone: this.form.phone,
              };
            } else {
              const msg = (res.data && res.data.message) || "提交失败";
              this.$message.error(msg);
              // 如后端返回已提交提示，则刷新并展示
              if (/已提交|重复/i.test(msg)) {
                this.fetchSeatDetail();
              }
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$message.error("提交失败");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-seat-claim {
  min-height: 100vh;
  background: #f5f7fa;
}
.container {
  max-width: 680px;
  margin: 0 auto;
  padding: 12px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  padding: 8px 0;
  text-align: center;
}
.mt12 {
  margin-top: 12px;
}
.p16 {
  padding: 16px;
}
.tc {
  text-align: center;
}
.tip {
  color: #909399;
}
</style>
